import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--chat-background);
  width: 100%;
  padding: 0 0 10px 0;
  height: 100%;
  overflow: hidden;

  .EmailInputHeader{
    width: 100%;
    height: 100px;
    background-color: var(--dark-blue);
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--white);

    span{
      font-size: 24px;
      font-weight: 300;
      line-height: 28px;
      font-family: roboto, sans-serif;
      margin-right: 20px;
    }

    img {
      width: 24px;
      margin: 0 20px;
      cursor: pointer;
      transition: transform 0.1s ease;
      
      &:active {
        transform: scale(0.9);
      }
      
      &:hover {
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 768px) {
    height: 50vh;
    overflow-y: scroll;
    padding-bottom: 10.5rem;
  }
`
export const FeedBackMenuContainer = styled.div`
  background-color: var(--dark-blue);
  margin: 0 auto; 
  display: flex;
  flex-direction: column;
  padding: 2% 2% 4% 2%;
  margin: 1rem 2rem ;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  position: relative;


  .buttonContainer{
    display:flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 70px;
    gap: 10px;
    width: 99%;
  }
  
  .titleContainer {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      color: var(--white);
      font-size: 1.5em;
      margin-bottom: 2rem;
      font-weight: 300;
      margin-right: 1%;

      @media (max-width: 768px) {
        margin-bottom: 0.2rem;
      }
    }

    .sub {
      font-size: 1em;
      color: var(--white);
      font-weight: 400;
      margin-bottom: 2rem;

      @media (max-width: 768px) {
        font-size: 0.875em;
        margin-bottom: 0.5rem;
      }
    }
  }

  .sendEmailContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .inputContainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      padding: 1%;
      height: auto;
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
      position: relative;
      
      @media (max-width: 768px) {
        input {
          min-height: 35px;
          font-size: 1rem;
        }
      }

      input {
        width: 100%;
        border: 0;
        outline: 0;
        font-weight: 400;
        color: #000 50%;
        outline: none;
        border: none;
        padding: 2%;
      }

      .iconsInput {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        right: 2rem;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        flex-direction: row;
        gap: 10px;
        z-index: 2;
      }
    }
  }
`;

export const CancelButton = styled.button`
  background-color: var(--white);
  color: var(--blue);
  height: 48px;
  width: 6em;
  padding: 2%;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    transform: scale(0.95);
    box-shadow: rgba(0, 0, 0, 0.2); 
    transition-delay: 0.5s;
  }
`;

export const ConfirmButton = styled.button`
  border: 0;
  outline: 0;
  background-color: var(--blue);
  padding: 2%;
  height: 48px;
  width: 8.125em;
  min-width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--white);
  font-size: 1em;

  &:active {
    transform: scale(0.95);
    box-shadow: rgba(0, 0, 0, 0.2); 
    transition-delay: 0.5s;
  }

  &:focus{
    outline: 2px solid var(--white);
    outline-offset: 2px;
  }
`;
export const SendEmailMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 2% 2% 4% 2%;
  background-color: white;
  width: 100%;
  height: auto;
  border-radius: 2px;
  background: rgba(255, 255, 255, 1);

  .confirm {
    display: flex;
    flex-direction: row;
  }

  .change {
    display: flex;
    flex-direction: row;
  }
`;

export const SendEmailMenuTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  .titulo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    color: var(--light-black);
  }

  .texto1 {
    display: flex;
    flex-direction: row;
    font-size: 1em;
    color: var(--light-black);
    margin-left: 0.4rem;
  }

  .texto2 {
    font-size: 0.875em;
    font-weight: 400;
    color: var(--clear-gray);
  }
`;

export const SendEmailButton = styled.button`
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-top-left-radius: 0.625rem;
  border-bottom-left-radius: 0.625rem;
  font-size: 1em;
  background-color: var(--blue);
  color: white;
  margin-right: 10px;
  outline: none;
  border: none;

  .checkedIcon {
    width: 1rem;
    height: auto;
    margin-right: 20px;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: row;
  }
`;

export const ChangeMail = styled.button`
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-top-left-radius: 0.625rem;
  border-bottom-left-radius: 0.625rem;
  font-size: 1em;
  background-color: var(--blue);
  color: white;
  margin-right: 10px;
  outline: none;
  border: none;

  .arrowIcon {
    width: 1rem;
    height: auto;
    margin-right: 20px;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: row;
  }
`;

export const LibrasButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3%;
  font-size: 1em;
  gap: 0.938rem;
  border-top-right-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
  background-color: var(--blue);
  color: white;
  border: none;
  outline: none;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }

  @media (max-width: 42.813) {
    font-size: 0.75rem;
    gap: 0.313rem;
  }
`;

export const EmojiContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 1rem;
  margin: auto;
  
  @media(max-width: 768px) {
    overflow: scroll;
    justify-content: space-between;
    padding: 10px 0px;
    gap: 0;
    margin: 0;
  }

  img {
    width: 48px;
    height: 48px;
    cursor: pointer;
    border-radius: 50%;
    border: 3px solid transparent;
    transition: transform 0.1s, box-shadow 0.2s;
    overflow-y: hidden;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }
  }
`;
